module.exports = __webpack_public_path__ + "img/correct.921d2555.png";